<ng-container *ngrxLet="loadMasterDataStatus$ as loadStatus">
    @switch (loadStatus) {
        @case ('in-progress') {
            <priva-loader
                [hasFooter]="true"
                class="master-data-loader"
                data-test="load-master-data-in-progress"
            >
                <priva-spinner />
                <ng-container data-footer>{{
                    'LOADING.TITLE.LOADING_DATA_FROM_REGISTRATION_SERVER' | translate
                }}</ng-container>
            </priva-loader>
        }
        @case ('error') {
            <div class="error-status-wrapper" data-test="load-master-data-failure-notification">
                <priva-notification status="danger">{{
                    'ERROR.TITLE.FAILED_TO_LOAD_MASTER_DATA' | translate
                }}</priva-notification>
                <button
                    priva-button
                    class="retry-btn"
                    importance="primary"
                    (click)="reloadMasterData()"
                    data-test="load-master-data-retry-btn"
                >
                    {{ 'GENERAL.ACTION.TRY_AGAIN' | translate }}
                </button>
            </div>
        }
        @case ('done') {
            <ng-content />
        }
    }
</ng-container>
